<template>
    <v-card class="default_card_wm ma-4" style="min-width: 98%" elevation="0">
        <v-row no-gutters>
            <v-col cols="12">
                <v-row no-gutters class="pt-2">
                    <v-col cols="6">
                        <v-select-filled
                            v-model="user.type"
                            :items="typesList"
                            item-value="value"
                            :item-title="(item: any) => item.text"
                            outlined
                            class="mx-1"
                            @update:model-value="onChangeType()"
                            data-cy="UserEdition-userType"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-switch
                            v-if="user.type === 'NATURAL_PERSON'"
                            v-model="isUserWithAccount"
                            class="py-0"
                            label="Activer le compte"
                            density="compact"
                            data-cy="UserEdition-isUserWithAccount"
                        />
                    </v-col>
                </v-row>
                <v-form v-model="formIsValid" v-if="user.type === 'NATURAL_PERSON'">
                    <v-row no-gutters class="pt-2">
                        <v-col cols="4" class="pr-2">
                            <v-text-field-filled
                                v-model="user.firstname"
                                type="text"
                                label="Prénom"
                                outlined
                                hide-details
                                data-cy="UserEdition-userFirstname"
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="4" class="pr-2">
                            <v-text-field-filled
                                v-model="user.lastname"
                                type="text"
                                label="Nom"
                                outlined
                                hide-details
                                :rules="[(v) => !!v || 'Un nom est requis']"
                                data-cy="UserEdition-userLastname"
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="4" v-if="isUserWithAccount || user.type === 'API_USER'">
                            <v-select-filled
                                v-model="profileId"
                                :items="availableProfiles"
                                :item-title="(item: any) => getProfileName(item)"
                                item-value="id"
                                v-if="availableProfiles && availableProfiles.length"
                                label="Profil utilisateur"
                                outlined
                                hide-details
                                :rules="[(p) => (!!p && !!p.length) || 'Sélectionnez un profil']"
                                density="compact"
                                data-cy="UserEdition-selectProfile"
                            />
                        </v-col>
                        <!-- <v-col cols="4" class="pr-2" v-else>
                                    <v-text-field
                                        outlined
                                        readonly
                                        dense
                                        hide-details
                                        type="text"
                                        label="Société"
                                        @click="windowStep = 'selectCompany'"
                                        v-model="user.company.name"
                                        v-if="user.company"
                                    ></v-text-field>
                                </v-col> -->
                    </v-row>
                    <v-row no-gutters class="pt-2" v-if="isUserWithAccount">
                        <v-col cols="4" class="pr-2">
                            <v-text-field-filled
                                v-model="user.email"
                                type="text"
                                outlined
                                hide-details="auto"
                                label="Email"
                                :disabled="user.id !== '' && !forcedWithAccountUser"
                                :rules="[
                                    (email) => emailPattern.test(email) || 'Un email est requis',
                                    (email) => !alreadyExistEmails[email] || 'L\'email existe déjà',
                                ]"
                                density="compact"
                                data-cy="UserEdition-email"
                            />
                        </v-col>
                        <v-col cols="4" class="pr-2">
                            <v-text-field-filled
                                outlined
                                readonly
                                hide-details
                                type="text"
                                :label="isFromUsersMenu ? 'Société' : 'Dossier'"
                                v-model="user.company.name"
                                v-if="user.company"
                                density="compact"
                                data-cy="UserEdition-dossier"
                            />
                        </v-col>
                        <v-col cols="4" v-if="displayPasswordInput">
                            <v-text-field-filled
                                outlined
                                required
                                label="Mot de passe"
                                type="password"
                                v-model="password"
                                :rules="[
                                    (p) =>
                                        (p && p.length >= 4) ||
                                        'Mot de passe requis (4 caractères minimum)',
                                ]"
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="pt-2">
                        <v-col cols="4" class="pr-2" v-if="isUserWithAccount && user.externalId">
                            <v-text-field-filled
                                outlined
                                dense
                                hide-details
                                readonly
                                type="text"
                                label="Identifiant externe"
                                v-model="user.externalId"
                            />
                        </v-col>
                    </v-row>
                    <template v-if="showIban">
                        <v-divider class="my-2" />
                        <v-row>
                            <v-col>
                                <span class="title ml-2"
                                    >Informations bancaires pour le paiement (Optionnel)</span
                                >
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field-filled
                                    v-model="selectedBankAccount.iban"
                                    label="IBAN"
                                    outlined
                                    hide-details
                                    :rules="[rules.checkIBAN]"
                                    @change="onIbanChanged(selectedBankAccount)"
                                    @input="onInputSetTruncatedIban()"
                                    data-cy="UserEdition-IBAN"
                                    density="compact"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-text-field-filled
                                    v-model="selectedBankAccount.bic"
                                    label="BIC"
                                    outlined
                                    hide-details
                                    :rules="[rules.checkBIC]"
                                    density="compact"
                                    data-cy="UserEdition-BIC"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field-filled
                                    v-model="selectedBankAccount.name"
                                    label="Nom de la banque"
                                    outlined
                                    hide-details
                                    density="compact"
                                />
                            </v-col>
                        </v-row>
                    </template>
                </v-form>
                <v-form v-model="formIsValid" v-else>
                    <v-row no-gutters class="pt-2">
                        <v-col cols="8" class="pr-2">
                            <v-text-field-filled
                                v-model="user.lastname"
                                type="text"
                                label="Nom de la société"
                                outlined
                                hide-details
                                :rules="[(v) => !!v || 'Le nom de l\'entreprise est requis']"
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="pt-2">
                        <v-col cols="5" class="pr-2">
                            <v-autocomplete-filled
                                v-model="user.legalForm"
                                :items="legalForms"
                                :item-title="formatItemTitle"
                                item-value="id"
                                label="Forme juridique"
                            />
                        </v-col>
                        <v-col cols="3" class="pr-2">
                            <v-text-field-filled
                                v-model="user.siret"
                                type="text"
                                @input="onInputSetTruncatedSiret()"
                                label="SIRET"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                    <template v-if="showIban">
                        <v-divider class="my-1" />
                        <v-row>
                            <v-col cols="6">
                                <v-text-field-filled
                                    v-model="selectedBankAccount.iban"
                                    label="IBAN"
                                    outlined
                                    hide-details
                                    :rules="[rules.checkIBAN]"
                                    @change="onIbanChanged(selectedBankAccount)"
                                    @input="onInputSetTruncatedIban()"
                                    density="compact"
                                    data-cy="UserEdition-IBAN"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-text-field-filled
                                    v-model="selectedBankAccount.bic"
                                    label="BIC"
                                    outlined
                                    hide-details
                                    :rules="[rules.checkBIC]"
                                    density="compact"
                                />
                            </v-col>
                        </v-row>
                    </template>
                </v-form>
            </v-col>
        </v-row>
        <!-- <oss-dialog
            v-model="dialogDisconnectUser"
            :title="'Retirer les droits de connexion'"
            @valid="deleteUser"
            :validTitle="'Retirer les droits des connexion de cet utilisateur'"
            width="1000px"
        >
            <v-row class="mx-2">
                <v-col>
                    Vous êtes sur le point de retirer le droits de connexion de
                    <b>{{ getUserDisplayName(user) }}</b> à la plateforme. Cet utilisateur ne sera
                    pas supprimer de votre société mais ne pourra plus se connecter.
                </v-col>
            </v-row>
        </oss-dialog> -->
    </v-card>
</template>

<script lang="ts">
import _ from "lodash";

import { UserBase } from "./UserBase";

import { Component, toNative } from "vue-facing-decorator";

@Component({
    emits: ["isValid"],
})
export class UserEditionLight extends UserBase {}

export default toNative(UserEditionLight);
</script>
<style scoped>
.selection .sticky-selection-header {
    position: sticky !important;
    z-index: 2 !important;
    top: 0 !important;
    /* height: 100px !important;  */
    width: 100% !important;
    background-color: white !important;
    box-sizing: border-box !important;
}

.selection {
    position: relative !important;
}
</style>
